// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as FuturePromise from "rescript-future/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let kvisteEndpoint = Env.cavavinUrl() + "/cart/update";

function encodeProduct(product) {
  let match;
  if (product.TAG === "Unit") {
    let match$1 = product._0;
    match = [
      match$1.quantity,
      match$1.stockKeepingUnit
    ];
  } else {
    let match$2 = product._0;
    match = [
      match$2.quantity.toNumber(),
      match$2.stockKeepingUnit
    ];
  }
  let stockKeepingUnit = match[1];
  if (stockKeepingUnit !== undefined) {
    return {
      TAG: "Ok",
      _0: Json.encodeDict(Object.fromEntries([
        [
          "quantity",
          Json.encodeNumber(match[0])
        ],
        [
          "reference",
          Json.encodeString(stockKeepingUnit)
        ]
      ]))
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}

let ResponseError = /* @__PURE__ */Primitive_exceptions.create("ResponseError");

function sendToKviste(cartProducts, shopId) {
  let payload = {};
  payload["cart"] = Json.encodeArray(Stdlib_Array.filterMap(cartProducts, product => {
    let product$1 = encodeProduct(product);
    if (product$1.TAG === "Ok") {
      return product$1._0;
    }
  }));
  return Future.mapError(FuturePromise.fromPromise(fetch(kvisteEndpoint, {
    method: "POST",
    body: Primitive_option.some(Json.stringify(Json.encodeDict(payload))),
    headers: Primitive_option.some(new Headers({
      "Content-Type": "application/json",
      "x-shop-id": shopId
    }))
  }).then(prim => prim.json()).then(json => {
    let dict = Json.decodeDict(json);
    if (dict === undefined) {
      return Promise.reject({
        RE_EXN_ID: ResponseError,
        _1: "Cannot decode json response"
      });
    }
    let match = Stdlib_Option.flatMap(dict["success"], Json.decodeBoolean);
    let match$1 = Stdlib_Option.flatMap(dict["sucess"], Json.decodeBoolean);
    let success = match !== undefined ? match : (
        match$1 !== undefined ? match$1 : Pervasives.failwith("Cannot decode success property")
      );
    let redirect = Stdlib_Option.flatMap(dict["redirect"], Json.decodeString);
    let decodeError = response => {
      let dict = Json.decodeDict(response);
      if (dict === undefined) {
        return;
      }
      let reference = Stdlib_Option.flatMap(dict["reference"], Json.decodeString);
      let message = Stdlib_Option.flatMap(dict["message"], Json.decodeString);
      if (message !== undefined) {
        return {
          message: message,
          reference: reference
        };
      }
    };
    let errors = Stdlib_Option.map(Stdlib_Option.flatMap(dict["errors"], errorsJson => {
      let arr = Json.decodeArray(errorsJson);
      if (arr !== undefined) {
        return arr;
      } else {
        return Stdlib_Option.map(Json.decodeDict(errorsJson), param => [errorsJson]);
      }
    }), errors => Stdlib_Array.filterMap(errors, decodeError));
    return Promise.resolve({
      success: success,
      redirect: redirect,
      errors: errors
    });
  })), undefined, param => I18n.t("Kviste service is temporarily unavailable."));
}

function checkProductDataKvisteAPI(cartProducts, shopId, notifier, onRequestCartRowsError, onRequestCartLoading) {
  onRequestCartLoading({
    message: undefined
  });
  Future.tapError(Future.mapOk(Future.tap(sendToKviste(cartProducts, shopId), param => onRequestCartLoading(undefined)), undefined, result => {
    let match = result.errors;
    let match$1 = result.redirect;
    if (match === undefined) {
      if (match$1 !== undefined && result.success) {
        return notifier.reset({
          TAG: "Success",
          _0: I18n.template(I18n.t("The order has successfully been sent to Kviste. [Get to cart]({{link}})"), {
            link: match$1
          }, undefined)
        }, undefined, undefined);
      } else {
        return;
      }
    }
    let details = match.map(error => error.message);
    notifier.reset({
      TAG: "Error",
      _0: I18n.t("The order could not be sent to Kviste.")
    }, details, undefined);
    onRequestCartRowsError(Stdlib_Array.filterMap(match, error => {
      let match = Stdlib_Array.filterMap(cartProducts, product => {
        let match;
        if (product.TAG === "Unit") {
          let match$1 = product._0;
          match = [
            match$1.id,
            match$1.stockKeepingUnit
          ];
        } else {
          let match$2 = product._0;
          match = [
            match$2.id,
            match$2.stockKeepingUnit
          ];
        }
        let sku = match[1];
        let match$3 = error.reference;
        if (sku !== undefined && match$3 !== undefined && sku === match$3) {
          return match[0];
        }
      });
      if (match.length !== 1) {
        return;
      }
      let productId = match[0];
      return {
        key: productId,
        message: I18n.t(error.message)
      };
    }));
  }), message => notifier.add({
    TAG: "Error",
    _0: message
  }, undefined, undefined));
}

export {
  kvisteEndpoint,
  checkProductDataKvisteAPI,
}
/* kvisteEndpoint Not a pure module */
